import { PasswordEditorState } from 'types/state';
import { createPasswordFormValues } from 'utils/createPasswordFormValues';

export const createPasswordEditorState = (): PasswordEditorState => ({
  formValues: createPasswordFormValues(),
  submited: false,
  submitDidSucceed: false
});
